import { render, staticRenderFns } from "./NewIndividual.vue?vue&type=template&id=1bcd03c0"
import script from "./NewIndividual.vue?vue&type=script&lang=js"
export * from "./NewIndividual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports